import { Component, OnInit } from '@angular/core';

import { HomePageService } from 'src/app/jobboard/components/pages/home/_services/home-page.service';
import { JobNumber } from 'src/app/jobboard/jobboard.model';

import { Router } from '@angular/router';

@Component({
    selector: 'app-agri-staff',
    templateUrl: './agri-staff.component.html',
    styleUrls: ['./agri-staff.component.scss']
})
export class AgriStaffComponent implements OnInit {

    constructor(private homeDataService: HomePageService, private router: Router) { 
    }

    agriJobs:number = 0;
    hortiJobs:number = 0;
    zooJobs:number = 0;
    medicVetJobs:number = 0;
    alimentsJobs:number = 0;
    totalJobs:number = 0;
    availableCompanies:number = 0;


    //Years of activity in HR
    yearsOfActivity : number = new Date().getFullYear() - 2010;

    abjStaff:boolean;
    abjSpecial:boolean;
    abjJunior:boolean;
    abjAbout:boolean;
    
    ngOnInit(): void {
        this.getJobsNumber();
        this.getAllCompanies();

        if(this.router.url.includes('-staff')){
            this.abjStaff = true;
        }
        if(this.router.url.includes('-specialisti')){
            this.abjSpecial = true;
        }
        if(this.router.url.includes('-junior')){
            this.abjJunior = true;
        }
        if(this.router.url.includes('-despre')){
            this.abjAbout = true;
        }

    }

    getJobsNumber() {
        return this.homeDataService.numberAvailableJobsFromActivitySectors().subscribe((jobs: Array<JobNumber>) => {
            jobs.forEach((job:JobNumber) => {

                this.totalJobs = this.totalJobs + job.number;

                if (job.sector == 'Agricultura'){
                    this.agriJobs = job.number;
                }
                if (job.sector == 'Horticultura'){
                    this.hortiJobs = job.number;
                }
                if (job.sector == 'Zootehnie'){
                    this.zooJobs = job.number;
                }
                if (job.sector == 'Medicina veterinara'){
                    this.medicVetJobs = job.number;
                }
                if (job.sector == 'Industria alimentara'){
                    this.alimentsJobs = job.number;
                }
            })
        }, error => {

        })
    }

    getAllCompanies() {
        this.homeDataService.listCompanies(8, 1, {}).subscribe((resp: any) => {
            this.availableCompanies = resp.totalElements;
        })
    }

}
